import Cookie from "js-cookie";

/**
 * Handles persistent dismissal of banner by setting a cookie.
 * Sets the block ID as the cookie name and "dismissed" as the value.
 * The cookie expires in 365 days.
 */
const banner = () => {
	const banners = document.querySelectorAll(".banner-block");

	if (!banners?.length) return;

	banners.forEach((banner) => {
		const isDismissed = Cookie.get(banner.id) === "dismissed";

		if (isDismissed) return;

		// display the banner if it hasn't been dismissed
		banner.style.display = "grid";

		const closeButton = banner.querySelector(".banner-block__close");

		if (!closeButton) return;

		closeButton.addEventListener("click", () => {
			// set a cookie to remember that the banner has been dismissed
			Cookie.set(banner.id, "dismissed", { expires: 365 });
			banner.style.display = "none";
		});
	});
};

export default banner;
